import {removeCurrent} from "@main/helpers";

export class Tabs {
    constructor(el) {
        this.el = el;
        this.menuItems = Array.from(this.el.querySelectorAll(".js-tabs-menu-item"));
        this.bodyItems = Array.from(this.el.querySelectorAll(".js-tabs-body"));
        this.initEvents();
    }

    initEvents() {
        this.menuItems.forEach((btn) => {
            btn.addEventListener("click", () => {
                if (!btn.classList.contains("current")) {
                    removeCurrent(this.menuItems);
                    removeCurrent(this.bodyItems);
                    const index = this.menuItems.indexOf(btn);
                    btn.classList.add("current");
                    this.bodyItems[index].classList.add("current");
                    if (this.bodyItems[index].classList.contains("js-test-list")) {
                        document.dispatchEvent(new CustomEvent("refreshStatistic"));
                    }
                }
            });
        });
    }
}
document.querySelectorAll(".js-tabs").forEach(elem => new Tabs(elem));
